import { Dispatch, SetStateAction, useState } from "react";

import IconButton from "../../../../elements/IconButton";
import { Layout, Prefill } from "../../../../types/GlobalInterfaces";
import { GlobalsTypes } from "../Globals";
import BasicTableView from "../../../supportal/CloudListView/BasicTableView";
import GlobalAppHeader from "./GlobalHeader";

/**
 * Uses GlobalAppHeader
 * Then BasicTableView to output all the Global items in list.
 *
 * Supports custom action for Quick Creates currently (sidebar visibility) (Subject to change)
 */
export function GlobalBody<T extends Layout | Prefill>({
  type,
  items,
  loadingItems,
  onEditGlobal,
  updateID,
  deleteID,
  updateGlobal,
  handleDelete,
  setCreateDrawerOpen,
  selectedLayoutType,
  setLayoutType,
}: {
  type: GlobalsTypes;
  items: T[];
  loadingItems: boolean;
  onEditGlobal: (item: T) => void;
  updateID: string | null | undefined;
  deleteID: string | null | undefined;
  updateGlobal: any;
  handleDelete: (id: string, type: GlobalsTypes) => void;
  setCreateDrawerOpen: () => void;
  selectedLayoutType?: string | null;
  setLayoutType?: Dispatch<SetStateAction<string | null>>;
}) {
  const [searchWord, setSearchWord] = useState<string | null>(null);
  const [selectedModule, setSelectedModule] = useState<string>("");

  const getFilteredGlobals = () => {
    if (!selectedModule && !searchWord && !selectedLayoutType) return items;

    if (!Array.isArray(items)) return [];

    return items.filter((g) => {
      if (selectedModule && g.ModuleAPIName !== selectedModule) return false;

      if (selectedLayoutType && (g as Layout).Type !== selectedLayoutType)
        return false;

      if (!searchWord) return true;

      const search = searchWord.toLowerCase();

      return (
        g.ModuleAPIName.toLowerCase().includes(search) ||
        g.Name.toLowerCase().includes(search)
      );
    });
  };

  const filteredItems = getFilteredGlobals();

  return (
    <>
      <div>
        <GlobalAppHeader
          items={items}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          selectedLayoutType={selectedLayoutType}
          setLayoutType={setLayoutType}
          setSearchWord={setSearchWord}
          type={type}
          setCreateDrawerOpen={setCreateDrawerOpen}
        />
        <BasicTableView
          loading={loadingItems}
          items={filteredItems}
          emptyMessage={
            items.length === 0
              ? "No items have been added."
              : "No items were found based on your search."
          }
          title="Name"
          getItemSubtitle={(g) => g.ModuleAPIName}
          getItemTitle={(g) => g.Name}
          CustomRenderer={(g) => {
            return (
              <div>
                {type === "QuickCreates" && (
                  <IconButton
                    icon={(g as Prefill)?.ShowInSidebar ? "eye" : "eye-off"}
                    tooltipText={
                      (g as Prefill)?.ShowInSidebar
                        ? "Quick Create is visible in the Sidebar. Click to hide"
                        : "Quick Create is not visible in the sidebar. Click to show"
                    }
                    onClick={() => handleVisibility(g as Prefill)}
                    loading={g?.id === updateID}
                  />
                )}
                <IconButton
                  icon="pencil"
                  tooltipText="Edit Quick Create"
                  onClick={() => onEditGlobal(g)}
                />
                <IconButton
                  icon="close"
                  tooltipText="Delete Quick Create"
                  onClick={() => handleDelete(g?.id, type)}
                  color="danger"
                  loading={g?.id === deleteID}
                />
              </div>
            );
          }}
        />
      </div>
    </>
  );

  function handleVisibility(g: Prefill) {
    g.ShowInSidebar = !g?.ShowInSidebar;

    updateGlobal({
      id: g?.id,
      payload: g,
    });
  }
}
